import React from 'react';
import classNames from 'classnames';
import styles from './SettingsButton.module.scss';

export const SettingsButton = ({name, alias, type, action, activeItem}) => {
  return (
    <button
      className={classNames(styles.button, {[styles[type]]: type}, {[styles.active]: activeItem})}
      onClick={action}
    >
      <div className={styles.icon}>
        <img src={`/${name}.svg`} width="100%" alt="" />
      </div>
      {alias && <span className={styles.name}>{alias.toUpperCase()}</span>}
    </button>
  )
};

export default SettingsButton;